import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './Navbar.css';
import { useNavigate } from 'react-router-dom';
import { UserContext } from "../configs/UserContext";
import { getBasket } from "../configs/ordersConfig";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { logoutMethod } from '../configs/auth';


function Navbar() {

    const [isClosed, setIsClosed] = useState(true);
    const [basketLength, setBasketLength] = useState('');
    const navigate = useNavigate();
    const { user, setUser } = useContext(UserContext);
    const location = useLocation();

    useEffect(() => {
        setIsClosed(true);
    }, [location.pathname]);

    const handleLogout = async () => {
        logoutMethod();
        setUser('');
        navigate('/');
    };

    useEffect(() => {
        const handleClick = () => {
            const basket = getBasket();

            let quantitys = 0;
            basket.map((product, index) => (
                quantitys += product.quantity
            ))
            
            setBasketLength(quantitys || "");
    
            const refreshtoken = sessionStorage.getItem('refreshtoken');
            const jsonRefresh = JSON.parse(refreshtoken);
            
            if (!refreshtoken) {
                setUser('');
                return;
            }
    
            const now = new Date();
    
            if (now.getTime() > jsonRefresh.expiry) {
                sessionStorage.removeItem('refreshtoken');
                toast.error('Lejárt a munkamenet, jelentkezz be újra!');
                navigate('/');
                setUser('');
            } else {
                setUser(jsonRefresh.role);
            }
        };
    
        document.addEventListener("click", handleClick);
    
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, []);
    

    const changeNavbarMenu = () => {
        switch(user){
            case 'user':
                return [
                    <Link to="/account" key='fiokom-page' className="dropdown-item">Rendeléseim</Link>,
                    <button className="dropdown-item" key='logout-button' onClick={()=>handleLogout()}>Kijelentkezés</button>
                ] 
            case 'admin': 
                return [
                    <Link to="/admin/adminsettings" key='adminsettings-page' className="dropdown-item">Központ</Link>,
                    <button className="dropdown-item" key='logout-button' onClick={()=>handleLogout()}>Kijelentkezés</button>
                ];  
            default:
                return [
                    <Link to="/login" key='login-page' className="dropdown-item">Bejelentkezés</Link>,
                    <Link to="/registration" key='registration-page' className="dropdown-item">Regisztráció</Link>
                ];
        }
    };


    return (
        <nav className='navbar navbar-expand-md flex-column p-0'>

            <div className='col-12' id='navbarName'>
                <div className='container-lg d-flex justify-content-md-around justify-content-between p-1 px-2'>
                    <a className="navbar-brand" href="/">Kreatív örömök</a>

                    <ul className="d-none d-md-flex flex-row m-0 p-0 col-1 justify-content-around">

                        <li className="nav-item dropdown">
                            <a className="nav-link text-white" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                            </a>
                            <ul className="dropdown-menu dropdown-menu-end ms-2">

                                {
                                   changeNavbarMenu()
                                }

                            </ul>
                        </li>

                        <li className="nav-item position-relative">
                            <Link to='/basket' className="nav-link text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-cart"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>

                                <span className={`position-absolute start-100 start-md-100 translate-middle badge rounded-circle bg-primary px-2`}>{basketLength}</span>
                            </Link>
                        </li>
                    </ul>
                    <button
                        onClick={()=>setIsClosed(!isClosed)}
                        className="navbar-toggler button"
                        type="button"
                        data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation"
                        >
                        <span className={`burger burger-5 ${isClosed ? '' : 'is-closed'}`}></span>
                    </button>
                </div>
            </div>
            
            <div className='col-12' id='navbarMenu'>
                <div className='container-lg'>
                <div className={`collapse navbar-collapse ${isClosed ? '' : 'show'} justify-content-center`} id="navbarNavDropdown">
                    <ul className="navbar-nav col-11 col-lg-10 justify-content-between">
                        <li className="nav-item">
                            <Link className="nav-link" to="/">Kezdőlap</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to={'/products/prepared_materials'}>Kézműves csomagok</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/products/finished_products">Kész termékek</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/products/materials">Alapanyagok</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/guides">Útmutatók</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/contact">Rólam/Kapcsolat</Link>
                        </li>
                        <ul className="navbar-nav d-flex flex-row col-2 justify-content-around d-md-none">


                        <li className="nav-item dropdown">
                            <a className="nav-link" href="#" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                            </a>
                            <ul className="dropdown-menu dropdown-menu-start position-absolute">

                                {
                                   changeNavbarMenu()
                                }

                            </ul>
                        </li>

                        <li className="nav-item position-relative">
                            <Link to='/basket' className="nav-link">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-cart"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>

                                <span className={`position-absolute start-100 start-md-100 translate-middle badge rounded-circle bg-primary px-2`}>{basketLength}</span>
                            </Link>
                        </li>
                    </ul>
                    </ul>
                </div>
                </div>
            </div>

        </nav>

    );
}

export default Navbar;